var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        {
          staticClass: "cell is-col-span-1 is-flex",
          staticStyle: { position: "relative" },
          attrs: { inert: _vm.isSaving },
          on: { focusout: _vm.onComponentFocusOut },
        },
        [
          _vm.isSaving
            ? _c("div", { staticClass: "quote-item-saving-overlay" })
            : _vm._e(),
          _c(
            "article",
            { staticClass: "box is-flex-grow-1" },
            [
              _c("div", { staticClass: "columns mb-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "column is-flex is-align-items-center",
                    staticStyle: { position: "relative" },
                  },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isNewCustomerPrompt,
                            expression: "isNewCustomerPrompt",
                          },
                        ],
                        staticClass: "icon is-synced-icon",
                        class: ["has-text-warning"],
                      },
                      [_c("i", { staticClass: "mdi mdi-circle-medium" })]
                    ),
                    _c("i", {
                      staticClass: "icon mdi mdi-account-outline mdi-24px",
                    }),
                    _c("p", { staticClass: "title pl-1" }, [
                      _vm._v("Customer "),
                      _vm.innerCustomer.isNew
                        ? _c("span", {
                            staticClass:
                              "has-badge-rounded has-badge-small has-badge-info",
                            attrs: { "data-badge": "New" },
                          })
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "column is-flex is-justify-content-flex-end" },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-smooth is-size-7",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerCustomer.isPerson,
                                expression: "innerCustomer.isPerson",
                              },
                            ],
                            attrs: {
                              id: "chk-pretty-customer-type",
                              name: "chk-pretty-customer-type",
                              type: "radio",
                            },
                            domProps: {
                              value: false,
                              checked: _vm._q(
                                _vm.innerCustomer.isPerson,
                                false
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.innerCustomer,
                                  "isPerson",
                                  false
                                )
                              },
                            },
                          }),
                          _vm._m(0),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-smooth is-size-7",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerCustomer.isPerson,
                                expression: "innerCustomer.isPerson",
                              },
                            ],
                            attrs: {
                              id: "chk-pretty-customer-type",
                              name: "chk-pretty-customer-type",
                              type: "radio",
                            },
                            domProps: {
                              value: true,
                              checked: _vm._q(_vm.innerCustomer.isPerson, true),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.innerCustomer,
                                  "isPerson",
                                  true
                                )
                              },
                            },
                          }),
                          _vm._m(1),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "is-divider" }),
              _c("div", { staticClass: "field" }, [
                !_vm.innerCustomer.isPerson
                  ? _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label is-required-label" }, [
                        _vm._v("Company Name"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("bulma-autocomplete", {
                            attrs: {
                              data: _vm.filteredCustomers,
                              field: "companyName",
                              loading: _vm.isSearchingCustomer,
                              expanded: true,
                              "open-on-focus": _vm.innerCustomer.isNew,
                              "class-prop": !_vm.$v.customer.companyName.$error
                                ? "is-required-field"
                                : "is-invalid",
                              placeholder: "Company Name",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.searchCustomer("companyName")
                              },
                              select: _vm.selectCustomer,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c("div", [
                                        _vm._v(_vm._s(props.option.value)),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "help is-primary" },
                                        [
                                          _c("span", { staticClass: "pr-1" }, [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-phone mdi-12px",
                                            }),
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(props.option.phoneNo)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2724649755
                            ),
                            model: {
                              value: _vm.innerCustomer.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.innerCustomer, "companyName", $$v)
                              },
                              expression: "innerCustomer.companyName",
                            },
                          }),
                          _vm.$v.customer.companyName.$error &&
                          !_vm.$v.customer.companyName.ormMaxLength
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ormMessages.companyName.ormMaxLength
                                  )
                                ),
                              ])
                            : _vm.$v.customer.companyName.$error &&
                              (!_vm.$v.customer.companyName.required ||
                                !_vm.$v.customer.companyName
                                  .isNotWhitespaceOnly)
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v("Company Name is required"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "field-body" }, [
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "label",
                          { staticClass: "label is-required-label" },
                          [_vm._v("First Name")]
                        ),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("bulma-autocomplete", {
                              attrs: {
                                data: _vm.filteredCustomers,
                                field: "firstname",
                                loading: _vm.isSearchingCustomer,
                                expanded: true,
                                "open-on-focus": _vm.innerCustomer.isNew,
                                maxlength: 120,
                                "class-prop": !_vm.$v.customer.firstname.$error
                                  ? "is-required-field"
                                  : "is-invalid",
                                placeholder: "First Name",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.searchCustomer("firstname")
                                },
                                select: _vm.selectCustomer,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(props.option.value)),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "help is-primary" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pr-1" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-phone mdi-12px",
                                                }),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(props.option.phoneNo)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2724649755
                              ),
                              model: {
                                value: _vm.innerCustomer.firstname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.innerCustomer, "firstname", $$v)
                                },
                                expression: "innerCustomer.firstname",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "label",
                          { staticClass: "label is-required-label" },
                          [_vm._v("Last Name")]
                        ),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("bulma-autocomplete", {
                              attrs: {
                                data: _vm.filteredCustomers,
                                field: "lastname",
                                loading: _vm.isSearchingCustomer,
                                expanded: true,
                                "open-on-focus": _vm.innerCustomer.isNew,
                                maxlength: 120,
                                "class-prop": !_vm.$v.customer.lastname.$error
                                  ? "is-required-field"
                                  : "is-invalid",
                                placeholder: "Last Name",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.searchCustomer("lastname")
                                },
                                select: _vm.selectCustomer,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(props.option.value)),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "help is-primary" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pr-1" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-phone mdi-12px",
                                                }),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(props.option.phoneNo)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2724649755
                              ),
                              model: {
                                value: _vm.innerCustomer.lastname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.innerCustomer, "lastname", $$v)
                                },
                                expression: "innerCustomer.lastname",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
              ]),
              _c(
                "transition",
                {
                  attrs: {
                    name: "custom-classes-transition",
                    "enter-active-class":
                      "animate__animated animate__fadeIn animate__faster",
                    "leave-active-class":
                      "animate__animated animate__fadeOut animate__faster",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$showMoreCustomer,
                          expression: "$showMoreCustomer",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between",
                            },
                            [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Emails"),
                              ]),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.activeEmails.length < 2,
                                        expression: "activeEmails.length < 2",
                                      },
                                    ],
                                    staticClass:
                                      "button is-small is-primary is-light tooltip p-0",
                                    class: `is-light-btn-${_vm.$theme.name}`,
                                    attrs: { "data-tooltip": "Add Email" },
                                    on: { click: _vm.addEmail },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-24px" },
                                      [_vm._v("add")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._l(_vm.activeEmails, function (email, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "field" },
                              [
                                _c("div", { staticClass: "field has-addons" }, [
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "span",
                                      { staticClass: "select custom-select" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: email.type,
                                                expression: "email.type",
                                              },
                                            ],
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  email,
                                                  "type",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            _vm.emailTypes,
                                            function (emailType, p) {
                                              return _c(
                                                "option",
                                                {
                                                  key: p,
                                                  attrs: { title: p },
                                                  domProps: {
                                                    value: emailType,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(Array.from(p)[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "control is-expanded has-icons-right",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: email.address,
                                            expression: "email.address",
                                          },
                                          {
                                            name: "focus-inserted",
                                            rawName: "v-focus-inserted",
                                            value: { focus: email.isNew },
                                            expression:
                                              "{ focus: email.isNew }",
                                          },
                                        ],
                                        staticClass: "input",
                                        class: [
                                          !_vm.$v.customer.emails.$each[index]
                                            .address.email
                                            ? "is-invalid"
                                            : "",
                                        ],
                                        attrs: {
                                          type: "email",
                                          placeholder: "Email",
                                        },
                                        domProps: { value: email.address },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              email,
                                              "address",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "icon is-right cursor-pointer",
                                          class: [
                                            email.isDefault
                                              ? "has-text-gold"
                                              : "has-text-grey-light",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.setDefaultEmail(index)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-star mdi-24px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button has-text-danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteEmail(email, index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon mdi mdi-minus mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between",
                            },
                            [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Phones"),
                              ]),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.activePhones.length < 3,
                                        expression: "activePhones.length < 3",
                                      },
                                    ],
                                    staticClass:
                                      "button is-small is-primary is-light p-0",
                                    class: `is-light-btn-${_vm.$theme.name}`,
                                    on: { click: _vm.addPhone },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-24px" },
                                      [_vm._v("add")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._l(_vm.activePhones, function (phone, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "field" },
                              [
                                _c("div", { staticClass: "field has-addons" }, [
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "span",
                                      { staticClass: "select custom-select" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: phone.type,
                                                expression: "phone.type",
                                              },
                                            ],
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  phone,
                                                  "type",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            _vm.phoneTypes,
                                            function (phoneType, p) {
                                              return _c(
                                                "option",
                                                {
                                                  key: p,
                                                  attrs: { title: p },
                                                  domProps: {
                                                    value: phoneType,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(Array.from(p)[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "control is-expanded has-icons-right",
                                    },
                                    [
                                      _c("the-mask", {
                                        directives: [
                                          {
                                            name: "focus-inserted",
                                            rawName: "v-focus-inserted",
                                            value: { focus: phone.isNew },
                                            expression: "{ focus: phone.isNew}",
                                          },
                                        ],
                                        staticClass: "input",
                                        attrs: {
                                          mask: _vm.phoneNoMask,
                                          tokens: _vm.phoneNoTokens,
                                          placeholder: "Phone",
                                        },
                                        model: {
                                          value: phone.no,
                                          callback: function ($$v) {
                                            _vm.$set(phone, "no", $$v)
                                          },
                                          expression: "phone.no",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "icon is-right cursor-pointer",
                                          class: [
                                            phone.isDefault
                                              ? "has-text-gold"
                                              : "has-text-grey-light",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.setDefaultPhone(index)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-star mdi-24px",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button has-text-danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deletePhone(phone, index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon mdi mdi-minus mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "field alt-contact-section" },
                        [
                          !_vm.innerCustomerAltContact
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex is-justify-content-space-between is-align-items-center",
                                  },
                                  [
                                    _c("label", { staticClass: "label mb-0" }, [
                                      _vm._v("Alternative Customer Contact"),
                                    ]),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-small is-primary is-light tooltip p-0",
                                        class: `is-light-btn-${_vm.$theme.name}`,
                                        attrs: {
                                          "data-tooltip":
                                            "Add Alternative Contact",
                                        },
                                        on: { click: _vm.addAltContact },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "msr msr-24px" },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex is-justify-content-space-between is-align-items-center",
                                  },
                                  [
                                    _c("label", { staticClass: "label mb-0" }, [
                                      _vm._v("Alternative Customer Contact"),
                                    ]),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-small is-danger is-light tooltip p-0",
                                        class: `is-light-btn-${_vm.$theme.name}`,
                                        attrs: {
                                          "data-tooltip":
                                            "Remove Alternative Contact",
                                        },
                                        on: { click: _vm.removeAltContact },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "msr msr-24px" },
                                          [_vm._v("remove")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "field-body" }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "label is-required-label",
                                      },
                                      [_vm._v("First Name")]
                                    ),
                                    _c("div", { staticClass: "control" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.innerCustomerAltContact
                                                .contact.firstName,
                                            expression:
                                              "innerCustomerAltContact.contact.firstName",
                                          },
                                        ],
                                        staticClass: "input",
                                        class: {
                                          "is-invalid":
                                            _vm.$v.customer.contacts.$invalid &&
                                            !_vm.innerCustomerAltContact.contact
                                              .firstName,
                                        },
                                        attrs: {
                                          type: "text",
                                          maxlength: 120,
                                          placeholder: "First Name",
                                        },
                                        domProps: {
                                          value:
                                            _vm.innerCustomerAltContact.contact
                                              .firstName,
                                        },
                                        on: {
                                          input: [
                                            function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.innerCustomerAltContact
                                                  .contact,
                                                "firstName",
                                                $event.target.value
                                              )
                                            },
                                            function ($event) {
                                              _vm.innerCustomerAltContact.contact.firstName =
                                                $event.target.value.trim()
                                            },
                                          ],
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "label is-required-label",
                                      },
                                      [_vm._v("Last Name")]
                                    ),
                                    _c("div", { staticClass: "control" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.innerCustomerAltContact
                                                .contact.lastName,
                                            expression:
                                              "innerCustomerAltContact.contact.lastName",
                                          },
                                        ],
                                        staticClass: "input",
                                        class: {
                                          "is-invalid":
                                            _vm.$v.customer.contacts.$invalid &&
                                            !_vm.innerCustomerAltContact.contact
                                              .lastName,
                                        },
                                        attrs: {
                                          type: "text",
                                          maxlength: 120,
                                          placeholder: "Last Name",
                                        },
                                        domProps: {
                                          value:
                                            _vm.innerCustomerAltContact.contact
                                              .lastName,
                                        },
                                        on: {
                                          input: [
                                            function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.innerCustomerAltContact
                                                  .contact,
                                                "lastName",
                                                $event.target.value
                                              )
                                            },
                                            function ($event) {
                                              _vm.innerCustomerAltContact.contact.lastName =
                                                $event.target.value.trim()
                                            },
                                          ],
                                        },
                                      }),
                                    ]),
                                  ]),
                                ]),
                                _vm._l(
                                  _vm.innerCustomerAltContact.contact.phones,
                                  function (phone, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "field mt-2" },
                                      [
                                        phone.isDefault && !phone.isDeleted
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "field has-addons",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "control" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "select custom-select",
                                                      },
                                                      [
                                                        _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  phone.type,
                                                                expression:
                                                                  "phone.type",
                                                              },
                                                            ],
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  phone,
                                                                  "type",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.phoneTypes,
                                                            function (
                                                              phoneType,
                                                              p
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key: p,
                                                                  attrs: {
                                                                    title: p,
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      phoneType,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        Array.from(
                                                                          p
                                                                        )[0]
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "control is-expanded has-icons-right",
                                                  },
                                                  [
                                                    _c("the-mask", {
                                                      directives: [
                                                        {
                                                          name: "focus-inserted",
                                                          rawName:
                                                            "v-focus-inserted",
                                                          value: {
                                                            focus: phone.isNew,
                                                          },
                                                          expression:
                                                            "{ focus: phone.isNew}",
                                                        },
                                                      ],
                                                      staticClass: "input",
                                                      attrs: {
                                                        mask: _vm.phoneNoMask,
                                                        tokens:
                                                          _vm.phoneNoTokens,
                                                        placeholder: "Phone",
                                                      },
                                                      model: {
                                                        value: phone.no,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            phone,
                                                            "no",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "phone.no",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                              ],
                        ],
                        2
                      ),
                      _c("customer-address-input", {
                        ref: "addressInput",
                        model: {
                          value: _vm.defaultAddress,
                          callback: function ($$v) {
                            _vm.defaultAddress = $$v
                          },
                          expression: "defaultAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", { staticClass: "is-size-7" }, [_vm._v("Company")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", { staticClass: "is-size-7" }, [_vm._v("Person")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }